function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 221.01 210",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1",
    transform: "translate(24.398 23.183) scale(.7792)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18.94,
    cy: 133.37,
    r: 18.94,
    style: {
      fill: "#65ab65"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.94,
    cy: 190.2,
    r: 18.94,
    style: {
      fill: "#de7c73"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.94,
    cy: 76.54,
    r: 18.94,
    style: {
      fill: "#48b2d2"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.94,
    cy: 19.71,
    r: 18.94,
    style: {
      fill: "#e79933"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.71 45.9v46.2h92.7V138h-92.7v72h-59.4V0H221v45.9z",
    style: {
      fill: "gray"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.53905cde7ea8f7579a6c66f88628fd59.svg";
export { ForwardRef as ReactComponent };